<template>
  <main class="main " role="main">
    <section-header>
      <h2>Política de privacidad y Términos de uso</h2>
      <h2>WoyAccess App</h2>
      <p>Al usar WoyAccess app estás aceptando nuestros términos y condiciones de uso:</p>
    </section-header>
    <section-page>
      <div>
        <p>Al utilizar el sistema de control de tickets WoyAccess (en adelante “WA”) propiedad de BCP Solutions
          S.R.L (en Adelante BCP), usted (denominado en adelante como el “Usuario”) acepta los
          presentes términos y condiciones (en adelante Términos y Condiciones) que se detallan a continuación,
          prestando su total
          conformidad con éstas, por lo que se le solicita leer con atención los Términos y Condiciones, los cuales
          rigen el
          uso de nuestra aplicación y delimitan los alcances del control de tickets para eventos.
          constituyendo la totalidad del acuerdo entre el Usuario y BCP.</p>
        <p>Al utilizar el presente servicio prestado por WA, ud. declara ser mayor de 18 años y contar con plena
          capacidad
          legal para celebrar este tipo de control de tickets. WA asume que dicha declaración es veraz y no
          realizará
          ninguna acción a fin de verificarlo, siendo exclusiva responsabilidad del Usuario cualquier consecuencia
          posible
          derivada de su falsedad.</p>
        <hr>
        <h2>ANTECEDENTES</h2>
        <p>BCP es una sociedad constituida bajo las leyes de la República Argentina, con domicilio social en PASO 240
          1ro
          “D”,
          Ciudad Autónoma de Buenos Aires, CUIT Nro 30-71875814-5 dedicada a la venta de Entradas para espectáculos
          artísticos, culturales y/o deportivos (en adelante el “Evento”) exclusivamente a través de Internet (venta
          electrónica) y desarrollo de software informático.</p>
        <p>BCP actúa como mandataria, esto es, por cuenta y orden del promotor, productor, teatro y/o estadio del evento
          y/o
          espectáculo (en adelante el “Organizador”), poniendo a disposición del Organizador los servicios de venta y
          distribución digital de Entradas para el Evento, mediante la venta por Internet. como así también
          disponibiliza esta herramienta WA para falicitar el control de los tickets en el ingreso de los eventos
          previamente publicados en alguna de las plataformas disponibles de BCP.</p>
        <p>El Organizador es el único y exclusivo responsable de la producción, organización y ejecución del Evento, en
          forma
          oportuna y de conformidad a la ley.</p>
        <hr>
        <h2>CONDICIONES DE USO DE LA APLICACIÓN WoyAccess</h2>
        <p>El Usuario se compromete a hacer uso de la aplicación para dispositivos móviles WA con fines exclusivamente
          personales.
        </p>
        <p>Queda prohibida la descarga, modificación o alteración, en cualquier forma, de los contenidos publicados en
          la
          aplicación.
          El contenido y software de esta aplicación es propiedad de BCP y está protegido bajo las leyes internacionales
          y
          nacionales
          del derecho de autor y propiedad intelectual.</p>
        <p>El Usuario no podrá hacer uso de la aplicación ilícitos, que lesionen derechos e intereses de terceros,
          o
          que de cualquier forma puedan dañar, inutilizar, sobrecargar, deteriorar o impedir la normal utilización de
          los servidores
          de BCP, los equipos informáticos o los documentos, archivos y/o cualquier clase de contenidos almacenados en
          cualquier
          equipo informático de BCP. La infracción de las condiciones de uso de la aplicación por parte de un Usuario
          implicará la
          cancelación de su cuenta sin que ello genere ningún derecho a
          reembolso o indemnización en favor del Usuario infractor. Todo lo anterior, sin perjuicio de la expresa
          reserva de
          acciones legales tanto penales como civiles para los casos de infracción.</p>
        <p>El Usuario deberá necesariamente registrarse con una cuenta en la página web del proveedor de tickets
          seleccionado siempre y cuando el Proveedor de Tickets utilice los servicios prestados por BCP, aceptando
          expresamente los
          presentes Términos y Condiciones, lo cual será completamente gratuito.</p>
        <hr>
        <h2>SERVICIO AL CLIENTE</h2>
        <p>Con el fin de contestar cualquier duda que los Usuarios puedan tener sobre estos Términos y Condiciones y
          brindar
          soporte para intentar solucionar cualquier problema con los servicios prestados por BCP, los consumidores
          pueden
          ponerse en contacto con nuestra mesa de ayuda escribiendo al email info@bcpsolutions.com.ar</p>

        <hr>
        <h2>ALMACENAMIENTO DE INFORMACIÓN</h2>
        <p>BCP realiza un proceso de tratamiento de datos con el fin de celebrar con el Usuario un contrato de
          compraventa
          de
          entradas de los diferentes Eventos ofrecidos por cada Organizador que el Usuario libremente elige.</p>
        <p>Para realizar la transacción señalada, se almacenan datos de carácter personal del Usuario, previo
          consentimiento
          de
          éste, relativos a su nombre completo, documento nacional de identidad (DNI), teléfono, fecha de nacimiento,
          género
          y
          dirección de correo electrónico (en adelante “Datos Personales”).</p>
        <p>No se almacenan datos relativos a los medios de pago que el Usuario utiliza para celebrar la compraventa de
          Entradas
          para el Evento. Además, BCP no realiza ningún procedimiento de validación de los datos entregados por el
          Usuario,
          por
          lo que es de su responsabilidad la veracidad de los mismos.</p>
        <p>De conformidad con lo establecido en los presentes Términos y Condiciones, el servicio prestado por BCP es
          para
          uso
          exclusivo de personas mayores de edad. En ningún momento BCP almacenará información alguna relativa a personas
          menores
          de edad. En caso de que BCP identifique o cuente con una sospecha razonablemente fundada que un Usuario es
          menor
          de
          edad, se procederá inmediatamente a la eliminación de su cuenta y de toda la información relativa a dicho
          usuario,
          sin
          que ello generé ningún derecho a favor de dicho usuario.</p>
        <p>Al aceptar estos Términos y condiciones, el usuario controlador de tickets que de uso a la aplicación Ticket
          Control, se compromete a no divulgar, manipular o falsificar
          cualquier dato personal al que tenga acceso a través de la aplicación WoyAccess, y se compromete a dar
          aviso de forma inmediata ante la
          sospecha de fuga de información, o vulneración del sistema.
        </p>
        <hr>
        <h2>UTILIZACIÓN DE LA INFORMACIÓN DEL USUARIO</h2>
        <p>BCP utiliza la información del Usuario, previo consentimiento de éste, para su almacenamiento, con el fin de
          realizar
          la venta de Entradas para los distintos Eventos ofrecidos por cada Organizador. Asimismo, el uso de los Datos
          Personales en el sitio web tiene como única finalidad validar las órdenes de compra y mejorar la labor de
          información
          y comercialización de los productos y servicios prestados por BCP, conforme lo establece la Ley de Protección
          de
          Datos
          Personales N° 25.326.</p>
        <p>Tambín utiliza la información de cuenta de usuario para permitir el acceso a la aplicación WoyAccess,
          con este mismo fin BCP declara que puede realizar tareas adicionales para la validación
          del usuario que intenta iniciar sesión en la aplicación como por ejemplo el envío de emails o mensajes de
          texto con claves únicas temporales que permitan validar la identidad de los usuarios controladores.
        </p>
        <hr>
        <h2>MODIFICACIÓN O ELIMINACIÓN DE INFORMACIÓN DEL USUARIO</h2>
        <p>A requerimiento del Usuario, se procederá a eliminar los datos caducos y aquellos cuya exactitud no pueda ser
          establecida o cuya vigencia sea dudosa.</p>
        <p>Para iniciar el procedimiento de modificación o eliminación de los datos, el Usuario deberá enviar un correo
          electrónico a la dirección info@bcpsolutions.com.ar, solicitando la modificación o eliminación de los datos y
          explicando la razón de la solicitud.</p>
        <p>No obstante, los procedimientos descritos anteriormente, el Usuario podrá eliminar, en cualquier momento, su
          cuenta
          desde la plataforma web del cliente de BCP con el cual el usuario controlador se encuentra operando.</p>
        <hr>
        <h2>POLÍTICA DE PRIVACIDAD</h2>
        <p>BCP realiza activamente todos los esfuerzos razonablemente posibles para salvaguardar de la mejor manera
          posible
          la
          información que almacena sobre los Usuarios.</p>
        <p>El uso de los Datos Personales en el Sitio Web y/o aplicación móvil tiene como única finalidad validar las
          órdenes de compra y mejorar
          la
          labor de información y comercialización de los productos y servicios prestados. Dichos datos no serán
          traspasados
          a
          terceros, salvo personas o empresas relacionadas con BCP o ante la solicitud de un Juez.</p>
        <p>En razón de lo anterior se han implementado todas las medidas de seguridad para proteger los datos personales
          requeridos a los Usuarios que hacen uso de la página Web.</p>
        <hr>
        <h2>USO COOKIES Y SEGURIDAD INFORMÁTICA</h2>
        <p>El servidor de datos utilizado por parte de BCP contempla el envío de datos al navegador del Usuario para que
          se
          almacenen en el disco duro de su computadora y así permitir identificar las computadoras utilizadas por los
          Usuarios
          al tener acceso a nuestro sitio web, este proceso es conocido como el uso de "cookies" o "direcciones de IP".
          Mediante
          el uso de "cookies" o "direcciones de IP" BCP es capaz de ofrecer un servicio más personalizado a sus Usuarios
          dado
          que esto permite entre otras cosas, ofrecer campañas publicitarias y de promoción como a la vez medir el
          tamaño de
          nuestra audiencia y el flujo de tráfico en los distintos sitios que el cliente visita.</p>
        <p>BCP emplea la mejor tecnología disponible en términos de seguridad informática y realiza todos los esfuerzos
          posibles
          con la finalidad de proteger la información que almacena de cada Usuario. Sin perjuicio de ello, BCP declara y
          el
          Usuario reconoce expresamente que, como todo sistema informático, la página web o los servidores de BCP pueden
          ser
          pasibles de ataques cibernéticos o hackeos que pueden exponer total o parcialmente la información almacenada
          de
          cada
          Usuario, lo que de ningún modo generará responsabilidad alguna en cabeza de BCP.</p>
        <p>Por otro lado BCP declara que con fines de medición de performance utiliza o puede utilizar herramientas de
          terceros que cuentan con sus propias políticas de privacidad.</p>
        <p>Al utilizar la aplicación el usuario declara que acepta el uso de dichas herramientas las cuales se informa a
          continuación.</p>
        <ul>
          <li>-<a href="https://sentry.io/privacy/">Sentry</a></li>
          <li>-<a href="https://policies.google.com/privacy?hl=es">Google Analytics</a></li>
        </ul>
        <hr>
        <h2>EXENCIÓN DE RESPONSABILIDAD</h2>
        <p>A pesar del constante esfuerzo de BCP por entregar a sus Usuarios la mejor experiencia y calidad posible, la
          empresa
          no se obliga a que el sitio y/o aplicación WoyAccess esté libre de errores e interrupciones. En relación
          con lo anterior, no se garantiza
          la
          ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema
          informático
          (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático. Por
          lo
          anterior, BCP se exime, con toda la extensión permitida por el ordenamiento jurídico, de cualquier
          responsabilidad
          por
          los daños y perjuicios de toda naturaleza que puedan deberse a la presencia de virus o a la presencia de otros
          elementos en los contenidos que puedan producir alteraciones en el sistema informático, documentos
          electrónicos o
          ficheros de los usuarios.</p>
        <p>La cuenta de cada Usuario solo será accesible a través de una contraseña elegida libremente por cada Usuario.
          El
          Usuario acepta que dicha contraseña es de su exclusiva responsabilidad y se compromete a no revelarla a
          terceras
          personas. BCP por ningún motivo podrá ser responsable por la pérdida de Entradas o cualquier otra consecuencia
          negativa que un Usuario pueda sufrir a raíz de la pérdida o robo de la contraseña de su cuenta. Se recomienda
          y
          solicita al Usuario el cambio periódico de su contraseña.</p>
        <p>BCP, como ticketera digital, publica la información entregada por los Organizadores del Evento y no tiene
          injerencia
          en las condiciones comerciales que estos definan para cada Evento. Así como tampoco es responsable por cambios
          que
          se
          produzcan, previo o durante, en la configuración del mismo.</p>
        <p>El Usuario reconoce que el Organizador será el exclusivo responsable por todas las obligaciones y cargas por
          la
          realización del Evento, sin que pudiera imputarse a BCP algún tipo de responsabilidad en relación al mismo.
          BCP no se hace responsable por la suspensión del Evento, la cancelación, y/o de los daños o lesiones sufridas
          por
          los
          clientes o terceras personas durante el desarrollo del Evento. Tampoco se hace responsable de los gastos
          incurridos
          por los clientes para la compra, asistencia modificación y/o cancelación de algún Evento.</p>
      </div>
      <a href="mailto:info@woypass.com.ar" class="bt">Contactar</a>
    </section-page>
  </main>
</template>

<script setup lang="ts">
import api from "~/api";
import {onMounted} from "vue";
import SectionHeader from "~/components/sections/SectionHeader.vue";
import SectionPage from "~/components/sections/SectionPage.vue";

definePageMeta({layout: 'base-layout',});
const privacyContent = ref('');
onMounted(async () => {
  const privacy = await api.TermsAndConditions.getTermAndConditionByLanguage('es');
  privacyContent.value = privacy.data.content;
})

</script>